import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',

    '& > :not(:last-child)': {
      marginBottom: '0.5rem'
    }
  },

  tasks: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '200px',
    overflow: 'hidden auto'
  },

  subtask: {
    borderRadius: '0.25rem',
    padding: '0.25rem',
    cursor: 'pointer',
    minHeight: '24px',

    '&:hover': {
      backgroundColor: '#E6EAEC'
    }
  },

  button: {
    width: 'fit-content',
    height: 'auto'
  }
}))

export default useStyles
